import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ServicesBox1 from './ServicesBox1';
import ServicesBox2 from './ServicesBox2'
class Services extends Component {
	constructor(props) {
        super(props);
        this.state = {
            titleServices: [
                {
                    id: 1,
                    title: 'What We Do',
                }
            ]
        }
    }
    render() {
        return (
            <section className="flat-row flat-iconbox bg-theme" style={{ width: '100vw', marginLeft: 'calc(50% - 50vw)' }}>
                <div className="container-fluid">

					<div className="row" >
						{
							this.state.titleServices.map(data => (
								<div className="col-md-12" key={data.id}>
                                    <div className="title-section center">
                                        <h2 style={{ fontSize: '2rem', fontWeight: 800 }}>{data.title}</h2>
                                        <p style={{ maxWidth: '900px', margin: '8px auto 24px', opacity: 0.85 }}>
                                            Consulting and Training in MERL and Statistics tailored to your goals
                                        </p>
                                    </div>
									{/* <!-- /.title-section --> */}
								</div>

							))
						}
						
					</div>
					{/* <!-- /.row --> */}
					<ServicesBox1 />

					<div className="row">
						<div className="col-md-12">
							<div className="height80"></div>
						</div>
					</div>
					<ServicesBox2 />
                    
                    <div className="row">
						<div className="col-md-12">
							<div className="height80"></div>
                            <div className="center">
                                <div className="wrap-button s2">
                                    <Link to="/services-v1" className="flat-button">
                                        View All Services
                                    </Link>
                                </div>
                            </div>
						</div>
					</div>
				</div>
        	</section>
        // <!-- /.flat-row-iconbox -->

     
           
        );
    }
}

export default Services;
